import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import { SortableDirective } from './sortable.directive';
import { SplitPaneComponent } from './split-pane/split-pane.component';
import { LoaderComponent } from './loader/loader.component';
import { AuthModule } from '@app/core/auth';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { SelectclienteComponent } from './selectcliente/selectcliente.component';
import { SelectfincaComponent } from './selectfinca/selectfinca.component';
import { CellDateComponent } from './cell-date/cell-date.component';
import { NewclientFormComponent } from './newclient-form/newclient-form.component';
import { NewuserFormComponent } from './newuser-form/newuser-form.component';
import { BooleanFormatComponent } from './boolean-format/boolean-format';
import { SensorNameComponent } from './sensor-name/sensor-name';
import { ClientNameComponent } from './client-name/client-name';
import { ModuleNameComponent } from './module-name/module-name';
import { ClienteNameComponent } from './finca-name/finca-name';
import { StationNameComponent } from './station-name/station-name';
import { ModulePowerSupplyComponent } from './module-power-supply/module-power-supply';
import { SmartTableModule } from './smart-table/smart-table.module';

@NgModule({
  declarations: [
    SortableDirective,
    LoaderComponent,
    SplitPaneComponent,
    DatetimepickerComponent,
    CheckboxComponent,
    SelectclienteComponent,
    SelectfincaComponent,
    CellDateComponent,
    BooleanFormatComponent,
    SensorNameComponent,
    ClientNameComponent,
    ModuleNameComponent,
    ClienteNameComponent,
    StationNameComponent,
    ModulePowerSupplyComponent,
    NewclientFormComponent,
    NewuserFormComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    TranslateModule,
    SortableDirective,
    SmartTableModule,
    LoaderComponent,
    SplitPaneComponent,
    DatetimepickerComponent,
    CheckboxComponent,
    SelectclienteComponent,
    SelectfincaComponent,
    AuthModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    TranslateModule.forChild(),
    SmartTableModule,
    AuthModule
  ]
})
class SharedModule {}

export { SharedModule };
